import { Entity } from '../../../api/';
import { User } from './User';

export enum LocalAccountType {
    GUEST = 'guest',
    ADMINISTRATOR = 'administrator',
    USER = 'user'
}

export enum DomainType {
    ACTIVE_DIRECTORY = 'active_directory',
    ENTRA_ID = 'entra_id',
    WORKGROUP = 'workgroup'
}

export type LocalAccount = {
    guid: string;
    deviceId: string;
    sid: string;
    userName: string;
    fullName?: string;
    description?: string;
    logonCount: number;
    badPasswordCount: number;
    isDisabled: boolean;
    lastLogon?: Date;
    passwordLastSet?: Date;
    excludeTill?: Date;
    updateDate: Date;
    accountType: LocalAccountType;
    hostname: string;
    domainType: DomainType;
    boundAdEntity?: Entity;
};

export type LocalAccountsBoundAdEntityUser = Pick<User, 'guid' | 'displayName' | 'userName' | 'domainName' | 'status' | 'excludeTill'>;
